// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const useStickyfill = require('client-v2/common/hooks/stickyfill')

const bem = BemEntity('TopCallToActionExperimentAJumpToGrid')

function TopCallToActionExperimentAJumpToGrid(props) {
  return tag('a', {
    ref: useStickyfill(),
    className: classNames(
      bem.block(),
      props.className
    ),
    href: props.href
  },
    'Discover your next favorite thing'
  )
}

module.exports = TopCallToActionExperimentAJumpToGrid
